import React, { FunctionComponent, useEffect } from 'react';

import { Divider } from '@yandex-360/orb-components/dist/components/Divider';
import cn from 'classnames';
import { useSelector } from 'react-redux';

import {
    selectIsTeleMessengerConferencesHistory,
    selectIsTelemostDesktopIntegration,
} from '../../shared/features/config/selectors';
import { clearNotifications } from '../../shared/features/notifications/ps-notifications';
import { parentFrameCommunicator } from '../../shared/features/parent-frame-communicator';
import { countMetrika } from '../../shared/helpers/metrika';
import { replace, SCREENS } from '../../shared/helpers/navigation';
import { useActions } from '../../shared/hooks';
import { OutgoingEvents } from '../call/iframe-sagas/types';
import { ConferenceHistoryList } from './features/history-items/components/list';
import { OneColHeader } from './features/history-items/components/one-col-header';
import { TwoColHeader } from './features/history-items/components/two-col-header';
import { ArtifactsSidebar } from './features/sidebar';
import { useIsOneColLayout } from './hooks';
import { selectIsEmptyResult, selectIsFullFetchingFailed, selectSelectedSession } from './selectors';
import styles from './styles.css';

export const ConferencesHistoryPage: FunctionComponent = () => {
    const isOneColLayout = useIsOneColLayout();
    const selectedSession = useSelector(selectSelectedSession);
    const isResultEmpty = useSelector(selectIsEmptyResult);
    const isFullFetchingFailed = useSelector(selectIsFullFetchingFailed);
    const isTeleMessengerConferencesHistory = useSelector(selectIsTeleMessengerConferencesHistory);

    const actions = useActions({ clearNotifications });

    useEffect(() => {
        countMetrika('meeting_history', 'show');
    }, []);
    const isTelemostDesktopIntegration = useSelector(selectIsTelemostDesktopIntegration);

    const handleBackButtonClick = () => {
        if (isTeleMessengerConferencesHistory) {
            parentFrameCommunicator.sendMessage('messenger', {
                event: OutgoingEvents.BACK_BUTTON_CLICK,
            });

            return;
        }

        actions.clearNotifications();
        replace(SCREENS.CREATE_CALL);
    };

    return (
        <div
            className={cn(styles.ConferenceHistoryPage, {
                [styles.oneColLayout]: isOneColLayout,
                [styles.stub]: isResultEmpty || isFullFetchingFailed,
                [styles.telemostDesktopIntegration]: isTelemostDesktopIntegration,
            })}
        >
            <div className={styles.wrapper}>
                <div className={styles.left}>
                    {isOneColLayout && <OneColHeader onBackButtonClick={handleBackButtonClick} />}
                    {!isOneColLayout && (
                        <>
                            <TwoColHeader onBackButtonClick={handleBackButtonClick} />
                            <Divider size="sm" />
                        </>
                    )}
                    <ConferenceHistoryList />
                </div>
                {(!isOneColLayout || selectedSession) && (
                    <div className={styles.right}>
                        <ArtifactsSidebar />
                    </div>
                )}
            </div>
        </div>
    );
};
